import * as React from 'react';
import Alert, { AlertCategoryEnum } from './Alert';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { SaveCurrentPath } from '../../Core';

export const MultiStudyBrickwall = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Alert category={AlertCategoryEnum.Danger} show={true}>
            Please select a specific study to view this area. <a onClick={() => { SaveCurrentPath(location); navigate("/account/study") }}>Switch Study</a>
        </Alert>
    );
}
